export type CategoryItem = {
  slug: string;
  name: string;
  subtitle: string;
  description: string;
  icon: string;
};

export const categories: CategoryItem[] = [
  {
    slug: "new",
    name: "新番速递",
    subtitle: "本季热播新番",
    description: "每季度实时更新的热门新番，连载进度、更新状态一目了然，助你第一时间追上当季话题作品。",
    icon: "ri-flashlight-line",
  },
  {
    slug: "movie",
    name: "剧场版",
    subtitle: "大银幕剧场版",
    description: "精挑细选的口碑剧场版，涵盖热血、治愈、科幻等类型，为追求完整观影体验的你提供片单参考。",
    icon: "ri-movie-2-line",
  },
  {
    slug: "ova",
    name: "OVA专栏",
    subtitle: "限定OVA特辑",
    description: "收录人气番剧的特别篇与OVA，短小精悍的篇幅里藏着粉丝不容错过的限定剧情与高能场面。",
    icon: "ri-disc-line",
  },
  {
    slug: "classic",
    name: "经典典藏",
    subtitle: "值得反复回味的经典",
    description: "那些经得起时间考验的经典作品，无论是热血、治愈还是悬疑，都能在你的片单里占据一席之地。",
    icon: "ri-award-line",
  },
  {
    slug: "hot-blooded",
    name: "热血番",
    subtitle: "燃到沸腾的热血作",
    description: "战斗、运动、成长，热血番永远让人肾上腺素飙升。本分类汇集最燃的硬核作品，陪你一路打到结局。",
    icon: "ri-fire-line",
  },
  {
    slug: "healing",
    name: "治愈番",
    subtitle: "抚慰心灵的治愈作",
    description: "在快节奏的生活里，治愈番是一剂温柔的良药。日常、美食、温情，让疲惫的心在这里慢慢放松。",
    icon: "ri-plant-line",
  },
  {
    slug: "sci-fi",
    name: "科幻番",
    subtitle: "硬核脑洞科幻作",
    description: "从机甲到赛博朋克，从太空到人工智能。科幻番用天马行空的设定，带你探索人类与未来的边界。",
    icon: "ri-rocket-2-line",
  },
  {
    slug: "adventure",
    name: "冒险番",
    subtitle: "说走就走的冒险",
    description: "未知的世界、并肩的伙伴、旅途中的成长。冒险番以壮阔的旅程，满足你对远方的所有想象。",
    icon: "ri-compass-3-line",
  },
];